import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.map.js";
import request from '@/utils/request2';
export function claimsList(data) {
  return request.post('admin/audit/claims-review/list', data);
}
export function claimsDetail(data, type, type2) {
  console.log(data, type);
  let url = type == 2 ? 'admin/audit/claims-review/render' : 'admin/audit/claims-review/detail';
  return request.post(url, data).then(res => {
    if (!type2) {
      res.claimsInfo.claimsSort.map(i2 => {
        i2.auditOpinion2 = i2.auditOpinion;
        i2.auditOpinion = '';
        return i2;
      });
    }
    res.claimsInfo.claimsDocument.map(i2 => {
      if (!type2) {
        i2.auditOpinion2 = i2.auditOpinion;
        i2.auditOpinion = '';
      }
      i2.documentUrl.map((i, index) => {
        i.status = 'done';
        i.uid = index + 1;
        return i;
      });
      return i2;
    });
    return res;
  });
}
//下载zip
export function reviewZip(data) {
  return request.post('admin/audit/claims-review/zip', data);
}
//审核
export function claimsApprove(data) {
  data.isMailing = data.isMailing || 0;
  console.log(data, JSON.parse(data.claimsContent));
  return request.post('admin/audit/claims-review/approve', data);
}